import { render, staticRenderFns } from "./ComplexesActivate.vue?vue&type=template&id=d2fa3950&"
import script from "./ComplexesActivate.vue?vue&type=script&lang=js&"
export * from "./ComplexesActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports